import { Box, Flex, Header, StatusMessage, Text, Wizard } from '@driftt/dds'
import React from 'react'
import { useState } from 'react'

import {
  FLFormUrlInput,
  FLFormUrlInputProps,
  NoneForm,
} from 'components/Fastlane/shared/FLFormUrlInput/FLFormUrlInput'

import { useFLWizardStore } from '../FLCreationWizard.context'
import { StyledStepContainer } from '../FLCreationWizard.styles'
import { FLCreationWizardStepSidePanel } from '../FLCreationWizardStepSidePanel'

export const FLCreationWizardStepURL = () => {
  const {
    store: { form, formUrl, isManualFL, selectedFormId },
    setStore: setWizardStore,
    updateStore: updateWizardStore,
  } = useFLWizardStore()
  const [urlHasForms, setUrlHasForms] = useState(true)
  const [formHasNoId, setFormHasNoId] = useState(false)

  const handleFormUrlSubmit: FLFormUrlInputProps['onFormUrlSubmit'] = (
    newUrl
  ) => {
    if (newUrl === formUrl) {
      return
    }
    setWizardStore((curr) => ({
      ...curr,
      formUrl: newUrl,
      form: undefined,
      selectedFormId: undefined,
      isManualFL: false,
    }))
    setFormHasNoId(false)
    setUrlHasForms(true)
  }

  const handleFormUrlSuccess: FLFormUrlInputProps['onFormUrlSuccess'] = ({
    data: response,
  }) => {
    const hasFormsInResponse = response.forms.length > 0
    setUrlHasForms(hasFormsInResponse)
    if (!hasFormsInResponse) {
      updateWizardStore({
        form: NoneForm,
        selectedFormId: NoneForm.id,
        isManualFL: !hasFormsInResponse,
      })
    }
  }

  const handleFormSelect: FLFormUrlInputProps['onFormSelect'] = ({
    formId,
    form,
    isManualFL,
    isFormWithoutId,
  }) => {
    setFormHasNoId(isFormWithoutId)
    setWizardStore((curr) => ({
      ...curr,
      form,
      selectedFormId: formId,
      isManualFL,
      testSuccess: false,
    }))
  }

  return (
    <Wizard.Step split="center">
      <StyledStepContainer>
        <Flex direction="column" gap={2}>
          <Box>
            <Header variant="h3">What page does your form live on?</Header>
            <Text>
              This is the page you want to trigger Fastlane from. Drift will
              check the page for your form(s), which you will use to map the
              data to Drift attributes after its submission.
            </Text>
          </Box>
          <FLFormUrlInput
            defaultFormUrl={formUrl}
            defaultSelectedFormId={selectedFormId}
            onFormUrlSubmit={handleFormUrlSubmit}
            onFormUrlSuccess={handleFormUrlSuccess}
            onFormSelect={handleFormSelect}
          />
          {formHasNoId && (
            <StatusMessage variant="info">
              This form is missing a form ID. You might want to add an ID before
              continuing. You can still create the playbook — you just need to
              add JavaScript to the page.
            </StatusMessage>
          )}
          {!urlHasForms && (
            <StatusMessage variant="info">
              We weren't able to find a form on this page. You can still create
              the playbook, you'll just need to manually set up the form in the
              editor and add JavaScript to the page.
            </StatusMessage>
          )}
          {form?.quickSetupCompatible && (
            <Text>
              Just a few more questions and you&apos;ll be ready to go!
            </Text>
          )}
          {form &&
            form?.type !== 'NONE' &&
            !formHasNoId &&
            !form?.quickSetupCompatible && (
              <StatusMessage variant="info">
                Quick setup currently does not support this form type. You can
                still create the playbook — you just need to add JavaScript to
                the page.
              </StatusMessage>
            )}
          {urlHasForms && isManualFL && !formHasNoId && (
            <StatusMessage variant="info">
              Sorry we couldn&apos;t find the form you were looking for. You can
              still create the playbook, you&apos;ll just need to manually set
              up the form in the editor and add JavaScript to the page.
            </StatusMessage>
          )}
        </Flex>
        <Wizard.StepActionButton />
      </StyledStepContainer>
      <FLCreationWizardStepSidePanel variant="urlWindow" />
    </Wizard.Step>
  )
}
